import CryptoJS from "crypto-js";

// Encryption function
export const useEncryption = () => {
  const encrypt = (data) => {
    const secretKey = process.env.VUE_APP_ENCRYPTION_KEY;
    if (!secretKey) {
      console.error("Encryption key is missing");
      return;
    }

    // Encrypt the data using AES and the provided secret key
    try {
      const encrypted = CryptoJS.AES.encrypt(data, secretKey).toString();
      return encrypted;
    } catch (error) {
      console.error("Encryption error:", error);
      return null;
    }
  };

  // Decryption function
  const decrypt = (encryptedData) => {
    const secretKey = process.env.VUE_APP_ENCRYPTION_KEY;
    if (!secretKey) {
      console.error("Encryption key is missing");
      return;
    }

    // Handle empty encrypted data
    if (!encryptedData) {
      console.error("Encrypted data is missing or invalid");
      return null;
    }

    try {
      // Decrypt the data using AES and the provided secret key
      const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      // Handle potential decryption errors (when the decrypted data is not valid UTF-8)
      if (!decrypted) {
        console.error("Decryption failed: Invalid UTF-8 data");
        return null;
      }

      return decrypted;
    } catch (error) {
      console.error("Decryption error:", error);
      return null;
    }
  };

  return {
    encrypt,
    decrypt,
  };
};
